import { Box } from '@mui/material'
import React from 'react'
import { useState } from 'react';
import { Container, Row } from 'react-bootstrap'

import axios from 'axios';

export const Contact = () => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
    });
    
    const [successMessage, setSuccessMessage] = useState('');

    const [errors, setErrors] = useState({});

    const handleChange = (event) => {
        const { name, value } = event.target;

        // If the input is the phone number field, only allow numeric values
        if (name === "phone") {
            // Only allow numeric characters
            const filteredValue = value.replace(/\D/g, ''); // Remove non-numeric characters
            setFormData({ ...formData, [name]: filteredValue });
        } else {
            // For other fields, update normally
            setFormData({ ...formData, [name]: value });
        }

        // Clear any error message for that field
        setErrors({ ...errors, [name]: '' });
    };

    const validate = () => {
        const newErrors = {};
        // Check if name is empty
        if (!formData.name) newErrors.name = "Name is required.";

        // Check if email is empty
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
            newErrors.email = "Email address is invalid.";
        }

        // Check if phone is provided and valid
        if (!formData.phone) {
            newErrors.phone = "Phone number is required.";
        } else if (!/^\d{10}$/.test(formData.phone)) {
            newErrors.phone = "Phone number must be 10 digits.";
        }

        // Check if message is empty
        if (!formData.message) newErrors.message = "Message is required.";
        return newErrors;
    };
    

    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            const response = await axios.post(
            'http://10.20.20.123:8001/api/contact',
            formData
            );

            console.log('Server response:', response.data);

            setSuccessMessage('Form submitted successfully!');
            setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
            setErrors({});
            setTimeout(() => setSuccessMessage(''), 3000);

        } catch (error) {
            console.error('Error submitting form:', error);
            setSuccessMessage('Failed to submit form.');
            setTimeout(() => setSuccessMessage(''), 3000);
        }
    };




  return (
    <>
    
        {/* Fly With Us Banner */}
        <section className='about-page'>
            <div className='about-bg'>
                <div className='c-detail-shap-1 con-shap-c'>
                    <img src="../assets/images/whi-5.svg" alt="" />
                </div>
                
                <div className='about-shap-3'>
                    <img src="../assets/images/about-shap-1.png" alt="" />
                </div>
                <div className='about-shap-4'>
                    <img src="../assets/images/about-shap-2.png" alt="" />
                </div>
                <div className='about-shap-5 con-shap-c'>
                    <img src="../assets/images/about-shap-3.svg" alt="" />
                </div>
                <div className='con-shap'>
                    <img src="../assets/images/whi-3.svg" alt="" />
                </div>
                <Container>
                    <Row className='align-items-center'>
                        <div className='col-lg-5 d-lg-block d-none' data-aos="fade-right" data-aos-duration="2000">
                            <div className='position-relative'>
                                <div className='contact-img text-center'>
                                    <img src="../assets/images/contact-img.png" alt="" />
                                </div>
                                <div className='contact-shap-2'>
                                    <img src="../assets/images/contact-shap-2.svg" alt="" />
                                </div>
                                <div className='contact-shap-3'>
                                    <img src="../assets/images/contact-shap-3.svg" alt="" />
                                </div>
                                <div className='contact-shap-4'>
                                    <img src="../assets/images/contact-shap-4.svg" alt="" />
                                </div>
                                <div className='contact-shap-5'>
                                    <img src="../assets/images/contact-shap-5.svg" alt="" />
                                </div>
                                <div className='contact-shap-1'>
                                    <img src="../assets/images/white-arr.svg" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-5 padding-0' data-aos="fade-left" data-aos-duration="2000">
                            <div className='tech-content'>
                                <h2>Fly With Us</h2>
                                <p>Take your career to new heights with a team that values innovation, collaboration, and growth. At IMUII, we believe in empowering individuals to rise beyond limits. Whether you're just starting or looking to soar higher, your journey with us is just beginning. </p>
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </section>

        <section className='address-section'>
            <Container>
                <Row className='justify-content-center'>
                    {/* <div className="col-lg-4 col-sm-6 mb-20">
                        <div className='address-card text-center'>
                            <div className='position-relative mb-15'>
                                <div className='address-shap-2'>
                                    <img src="../assets/images/address-shap-2.svg" alt="" />
                                </div> 
                                <div className='address-shap-1'>
                                    <img src="../assets/images/address-shap-1.svg" alt="" />
                                </div> 
                            </div>
                            <h4>Nungambakkam</h4>
                            <p>616, Anna Salai, Nungambakkam, Chennai, Tamil Nadu 600006.</p>
                        </div>
                    </div> */}
                    <div className="col-lg-4 col-sm-6 mb-20">
                        <div className='address-card text-center'>
                            <div className='position-relative mb-15'>
                                <div className='address-shap-2'>
                                    <img src="../assets/images/address-shap-2.svg" alt="" />
                                </div> 
                                <div className='address-shap-3'>
                                    <img src="../assets/images/address-shap-3.svg" alt="" />
                                </div> 
                            </div>
                            <h4>Thousand Lights</h4>
                            <p>45, Anna Salai, Thousand Lights, Chennai, Tamil Nadu 600006.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-sm-6 mb-20 d-lg-block d-none">
                        <div className='address-card text-center position-relative'>
                            <div className='address-shap-5'>
                                <img src="../assets/images/address-shap-5.svg" alt="" />
                            </div>

                            <div className='address-shap-6'>
                                <img src="../assets/images/address-shap-6.svg" alt="" />
                                <div className='svg-position'>
                                    <svg
                                    version="1.1"
                                    id="L7"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 100 100"
                                    enableBackground="new 0 0 100 100"
                                    xmlSpace="preserve"
                                    >
                                    <path
                                        fill="#fff"
                                        d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3
                                        c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z"
                                    >
                                        <animateTransform
                                        attributeName="transform"
                                        attributeType="XML"
                                        type="rotate"
                                        dur="2s"
                                        from="0 50 50"
                                        to="360 50 50"
                                        repeatCount="indefinite"
                                        />
                                    </path>
                                    <path
                                        fill="#fff"
                                        d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7
                                        c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z"
                                    >
                                        <animateTransform
                                        attributeName="transform"
                                        attributeType="XML"
                                        type="rotate"
                                        dur="1s"
                                        from="0 50 50"
                                        to="-360 50 50"
                                        repeatCount="indefinite"
                                        />
                                    </path>
                                    <path
                                        fill="#000"
                                        d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5
                                        L82,35.7z"
                                    >
                                        <animateTransform
                                        attributeName="transform"
                                        attributeType="XML"
                                        type="rotate"
                                        dur="2s"
                                        from="0 50 50"
                                        to="360 50 50"
                                        repeatCount="indefinite"
                                        />
                                    </path>
                                    </svg>
                                </div>

                            </div>

                            <div className=' coming-flex'>
                                <div className='position-relative mb-1'>
                                    <div className='address-shap-8'>
                                        <img src="../assets/images/address-shap-8.svg" alt="" />
                                    </div>
                                    <div className='address-shap-7'>
                                        <img src="../assets/images/address-shap-7.svg" alt="" />
                                    </div>
                                    <div className='address-shap-4'>
                                        <img src="../assets/images/address-shap-4.svg" alt="" />
                                    </div>
                                </div>

                                <div className='position-relative d-flex'>
                                    <div className='address-shap-9'>
                                        <img src="../assets/images/address-shap-9.svg" alt="" />
                                    </div>
                                    <div className='address-shap-10'>
                                        <img src="../assets/images/address-shap-10.svg" alt="" />
                                    </div>
                                    <div className='address-shap-12'>
                                        <img src="../assets/images/address-shap-12.svg" alt="" />
                                    </div>
                                    <div className='address-shap-11'>
                                        <img src="../assets/images/address-shap-11.svg" alt="" />
                                    </div>
                                    <div className='address-shap-13'>
                                        <img src="../assets/images/address-shap-13.svg" alt="" />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </Row>
            </Container>
        </section>

        <section className='contact-section'>
            <Container>
                <Row className=''>
                    <div className="col-lg-6 mb-lg-0 mb-40">
                        <div className='contact-text' data-aos="fade-up-right" data-aos-duration="2000">
                            <h5>Contact Us</h5>
                            <h3>We’d love to Hear From <img className='send-icon' src="../assets/images/send-icon.svg" alt="" /> You.</h3>
                            <p>While we’re good with smoke signals, there are easier ways to get in touch.</p>
                        </div>
                        
                        <Row className='justify-content-center'>
                            <div className='col-lg-12 col-md-4 col-sm-6'>
                                <div className='mb-20'>
                                    <Box className='con-detail' sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px'
                                    }}>
                                        <div className='address-img-1'>
                                            <img src="../assets/images/form-shap-2.svg" alt="" />
                                        </div>
                                        <div className='address-text'>
                                            <h4>Hand Phone</h4>
                                            <p>+91 444 777 4011</p>
                                        </div>
                                    </Box>
                                </div>
                            </div>
                            <div className='col-lg-12 col-md-4 col-sm-6'>
                                <div className='mb-20'>
                                    <Box className='con-detail' sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px'
                                    }}>
                                        <div className='address-img-2'>
                                            <img src="../assets/images/form-shap-4.svg" alt="" />
                                        </div>
                                        <div className='address-text'>
                                            <h4>Our Mail</h4>
                                            <p>hr@imuii.com</p>
                                        </div>
                                    </Box>
                                </div>
                            </div>
                            <div className='col-lg-12 col-md-4 col-sm-6'>
                                <div className='mb-0'>
                                    <Box className='con-detail' sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px'
                                    }}>
                                        <div className='address-img-3'>
                                            <img src="../assets/images/form-shap-6.svg" alt="" />
                                        </div>
                                        <div className='address-text'>
                                            <h4>Main Branch</h4>
                                            <p>616, Anna Salai, Thousand Lights, Chennai, Tamil Nadu 600006.</p>
                                        </div>
                                    </Box>
                                </div>
                            </div>
                        </Row>
                        
                    </div>

                    <div className='col-lg-6 contact-msg '>



                        <form onSubmit={handleSubmit} className='position-relative'>

                            {successMessage && <div className='success-position' style={{ color: 'white', marginBottom: '10px', backgroundColor: 'green', padding: '8px 10px', borderRadius: '5px', fontSize: '14px' }}>{successMessage}</div>}
                            <Row>
                                <div className="col-lg-12 col-md-6">
                                    <div className='form-input'>
                                        <input type="text" id="name" placeholder='Name' name="name" value={formData.name} onChange={handleChange} required />

                                        {errors.name && <div style={{ color: '#BC1823', fontSize: '14px' , marginTop: '5px' }}>{errors.name}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6">
                                    <div className='form-input'>
                                        <input type="email" id="email" placeholder='Your Email' name="email" value={formData.email} onChange={handleChange} required />

                                        {errors.email && <div style={{ color: '#BC1823', fontSize: '14px' , marginTop: '5px' }}>{errors.email}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6">
                                    <div className='form-input'>
                                        <input type="tel" id="phone" placeholder='Phone Number' name="phone" value={formData.phone} onChange={handleChange} required />

                                        {errors.phone && <div style={{ color: '#BC1823', fontSize: '14px' , marginTop: '5px' }}>{errors.phone}</div>}
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-6">
                                    <div className='form-input'>
                                        <input type="text" id="subject" placeholder='Subject' name="subject" value={formData.subject} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className='form-input'>
                                        <textarea id="message" placeholder='Write a Message' name="message" value={formData.message} onChange={handleChange} required />

                                        {errors.message && <div style={{ color: '#BC1823', fontSize: '14px' }}>{errors.message}</div>}
                                    </div>
                                </div>
                            </Row>
                            
                            <div>
                                <button className='submit-btn' type="submit">Send Your Request</button>
                            </div>
                        </form>
                    </div>
                </Row>
            </Container>
        </section>

        <section className='map-padding'>
            <div className='google-map'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.7016790816883!2d80.24952207551593!3d13.05465121305108!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5267ab159f64e9%3A0xb7743db9d152516b!2sIMUII%20TECHNOLOGY%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1726741602708!5m2!1sen!2sin" style={{border: '0'}} allowFullScreen={""} loading={"lazy"} referrerPolicy="no-referrer-when-downgrade" title="IMUII Website" width= "100%" height= "100%" ></iframe>
            </div>
        </section>
    
    </>
  )
}
